import { onScopeDispose } from 'vue'

/**
 * Invokes `callback` every time the browser tab transitions to visible.
 *
 * Used to re-sync in-memory state that another device may have mutated
 * while this tab was backgrounded — e.g. `users.last_seen_log_at` behind
 * the header's log-unread indicator. The session cookie is the
 * source of truth, so a fetch on visibility-return clears stale badges
 * without needing a per-user ActionCable channel.
 *
 * Registers on `document` synchronously and cleans up via
 * `onScopeDispose`, which works in any reactive scope (component setups,
 * manual `effectScope` in tests).
 */
export function useRefreshOnVisible(callback: () => void | Promise<void>): void {
  const handler = (): void => {
    if (document.visibilityState === 'visible') void callback()
  }
  document.addEventListener('visibilitychange', handler)
  onScopeDispose(() => document.removeEventListener('visibilitychange', handler))
}
